'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getActiveErrorModalId = exports.getActiveErrorModalId = function getActiveErrorModalId(state) {
  return state.getIn(['app', 'modal', 'errorModal', 'activeModalId']);
};
var getErrorModalData = exports.getErrorModalData = function getErrorModalData(state) {
  return state.getIn(['app', 'modal', 'errorModal', 'data']);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/errorModalSelector.js
// module id = 1771
// module chunks = 0